import * as styles from './Sizes.module.scss';

export const RIGHT_PANEL_SHIFT_BREAKPOINT = parseInt(
  styles.rightPanelShiftBreakpoint,
  10,
);

const Sizes = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;

export type Size = (typeof Sizes)[keyof typeof Sizes];

export const MIN_MAX_WIDTHS: Record<Size, [number, number]> = {
  [Sizes.SM]: [0, 768],
  [Sizes.MD]: [768, 992],
  [Sizes.LG]: [992, Number.MAX_SAFE_INTEGER],
};

export type PostLayoutSize = 'mobile' | 'tablet' | 'desktop' | 'monitor';

const POST_LAYOUT_SIZES: [PostLayoutSize, number][] = [
  ['monitor', 1656],
  ['desktop', 916],
  ['tablet', 655],
  ['mobile', 0],
];

export function getCurrentPostLayoutSize({
  baseWidth,
}: {
  baseWidth: number;
}): PostLayoutSize {
  const [size] = POST_LAYOUT_SIZES.find(
    ([, breakpoint]) => baseWidth >= breakpoint,
  ) ?? ['mobile', 0];

  return size;
}

export default Sizes;
